/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dashfix_Routing_Other_FailoverInputs */

const en_dashfix_routing_other_failover = /** @type {(inputs: Dashfix_Routing_Other_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lanes · auto failover`)
};

const zh_hans1_dashfix_routing_other_failover = /** @type {(inputs: Dashfix_Routing_Other_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个数据源 · 自动切换`)
};

const pt_br2_dashfix_routing_other_failover = /** @type {(inputs: Dashfix_Routing_Other_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} fontes · failover automático`)
};

const es_dashfix_routing_other_failover = /** @type {(inputs: Dashfix_Routing_Other_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} fuentes · respaldo automático`)
};

const fr_dashfix_routing_other_failover = /** @type {(inputs: Dashfix_Routing_Other_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} sources · basculement auto`)
};

const de_dashfix_routing_other_failover = /** @type {(inputs: Dashfix_Routing_Other_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Quellen · automatisches Failover`)
};

const ru_dashfix_routing_other_failover = /** @type {(inputs: Dashfix_Routing_Other_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Источников: ${i?.count} · автоматическое переключение`)
};

const it_dashfix_routing_other_failover = /** @type {(inputs: Dashfix_Routing_Other_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} fonti · failover automatico`)
};

/**
* | output |
* | --- |
* | "{count} lanes · auto failover" |
*
* @param {Dashfix_Routing_Other_FailoverInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const dashfix_routing_other_failover = /** @type {((inputs: Dashfix_Routing_Other_FailoverInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashfix_Routing_Other_FailoverInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_dashfix_routing_other_failover(inputs)
	if (locale === "pt-BR") return pt_br2_dashfix_routing_other_failover(inputs)
	if (locale === "es") return es_dashfix_routing_other_failover(inputs)
	if (locale === "fr") return fr_dashfix_routing_other_failover(inputs)
	if (locale === "de") return de_dashfix_routing_other_failover(inputs)
	if (locale === "ru") return ru_dashfix_routing_other_failover(inputs)
	if (locale === "it") return it_dashfix_routing_other_failover(inputs)
	return en_dashfix_routing_other_failover(inputs)
});